import React from "react";
import styled from "styled-components";

import PresentationL from "../../Presentation/PresentationL";
import PresentationR from "../../Presentation/PresentationR";

const HomeContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  max-width: 1100px;
  min-height: 85vh;

  margin: 0 auto;
  padding: 0 80px;
  gap: 50px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    gap: 20px;
    text-align: center;
  }
`;
function Home() {
  return (
    <HomeContainer>
      <PresentationL />
      <PresentationR />
    </HomeContainer>
  );
}

export default Home;